<div>
  <div class="inner-page-header">
    <h3>{{ pageTitle }}</h3>
  </div>
  @if (spinner) {
    <app-spinner></app-spinner>
  } @else {
    <form [formGroup]="sopraServiceFormGroup">
      <div class="main-card">
        <div class="form-group width-50">
          <label for="" class="form-label">اسم الخدمة</label>
          <input
            type="text"
            formControlName="name"
            class="form-control"
            placeholder="يرجى كتابة اسم الخدمة"
            [readonly]="_sopraServiceId"
            [ngClass]="{
              'invalid-field':
                sopraServiceFormGroup.controls['name'].errors && submitted,
            }"
          />
        </div>

        <div class="form-group width-100">
          <label for="" class="form-label">وصف الخدمة داخل سوبرا</label>
          <div
            formControlName="description_for_expert"
            class="custom-height"
            [ngxSummernote]="summerNoteConfig"
            [class.ng-invalid]="
              submitted &&
              sopraServiceFormGroup.controls['description_for_expert'].invalid
            "
            [class.ng-touched]="
              sopraServiceFormGroup.controls['description_for_expert'].touched
            "
            [class.submitted]="submitted"
          ></div>
        </div>

        <div class="form-group width-50">
          <app-switch-input
            [label]="'تعيين افتراضي في سوبرا'"
            [labelEn]="'is_default_in_sopra'"
            [labelDesc]="'(مفعل/غير مفعل)'"
            [value]="
              sopraServiceFormGroup.controls['is_default_in_sopra'].value
            "
            (valueChanged)="isValueChanged($event, 'is_default_in_sopra')"
          >
          </app-switch-input>
        </div>

        <div class="form-group width-50">
          <app-switch-input
            [label]="'حال تفعيل الخدمة في سوبرا'"
            [labelEn]="'is_active_for_sopra'"
            [labelDesc]="'(مفعل/غير مفعل)'"
            [value]="
              sopraServiceFormGroup.controls['is_active_for_sopra'].value
            "
            (valueChanged)="isValueChanged($event, 'is_active_for_sopra')"
          >
          </app-switch-input>
        </div>

        <div class="form-group width-100">
          <label for="" class="form-label">شروط الخدمة</label>
          <div
            formControlName="terms_of_classification"
            class="custom-height"
            [ngxSummernote]="summerNoteConfig"
            [class.ng-invalid]="
              submitted &&
              sopraServiceFormGroup.controls['terms_of_classification'].invalid
            "
            [class.ng-touched]="
              sopraServiceFormGroup.controls['terms_of_classification'].touched
            "
            [class.submitted]="submitted"
          ></div>
        </div>

        <div class="files-needed" formArrayName="files">
          <button class="btn btn-add" (click)="addNeededFile()">
            <img alt="" src="assets/images/svg/add-service.svg" />
            اضافة ملف جديد
          </button>
          @for (
            neededFile of files.controls;
            let i = $index;
            track trackByFileId(i, neededFile)
          ) {
            <div [formGroupName]="i" class="file-wrapper">
              <div class="form-group file">
                <label for="" class="form-label">اسم الملف</label>
                <input
                  type="text"
                  formControlName="name"
                  class="form-control"
                  [ngClass]="{
                    'invalid-field':
                      neededFile.controls['name'].errors && submitted,
                  }"
                  placeholder="ادخل اسم الملف"
                />
              </div>
              <div class="checkBox-wrapper">
                <label class="checkbox-container">
                  <input
                    type="checkbox"
                    formControlName="has_expiry_date"
                    (click)="toggleHasExpiredDate($event, i)"
                  />
                  <span class="checkmark"> </span>
                </label>
                <span class="checkbox-label">مستند له تاريخ انتهاء</span>
              </div>
              @if (neededFile.get("has_expiry_date")?.value) {
                <div class="form-group">
                  <label for="" class="form-label">الصلاحية بالشهور</label>
                  <input
                    type="number"
                    formControlName="months_to_expire"
                    class="form-control"
                    [ngClass]="{
                      'invalid-field':
                        neededFile.controls['months_to_expire'].errors &&
                        submitted,
                    }"
                    placeholder="ادخل مدة انتهاء الصلاحية"
                  />
                </div>
              }
              <button
                class="btn btn-add delete-file"
                (click)="removeNeededFile(i)"
              >
                <img alt="" src="assets/images/svg/DELETE1.svg" />
              </button>
            </div>
          }
        </div>
        @if (showErrorMessage) {
          <div class="alert-box mt-3 mb-0">
            <img
              src="assets/images/svg/error-icon.svg"
              class="close-alert"
              (click)="closeError()"
              alt=""
            />
            <p class="alert-msg">{{ errorMessage }}</p>
          </div>
        }
      </div>

      <div class="save-section col-md-12 px-4 pb-4">
        <div class="save-btn-wrapper">
          <app-action-button (submitAction)="save($event)"></app-action-button>
        </div>
      </div>
    </form>
  }
</div>
